import React, { useState, useContext, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Pathname } from 'Routes';
import { AppContext, AuthContext } from 'Context';
import {
  PhotoAlbum as AlbumIcon,
  Collections as AllAlbumsIcon,
    Add as AddIcon,
} from '@material-ui/icons';
import styles from './CategoriesSidebar.module.css';

const AlbumsSidebar = ({
  albums = [],
  selectedAlbum,
  onAlbumSelect,
  loading = false,
  totalAlbumsCount = 0
}) => {
    const navigate = useNavigate();
    const {
      setAppSnackbar,
      setUpdateType,
setChooseAlbumStep
    } = useContext(AppContext);
  const handleAlbumClick = (album) => {
    onAlbumSelect(album);
  };

  const handleAllAlbumsClick = () => {
    onAlbumSelect(null);
  };
const handleAddAlbum = () => {
  navigate(`${Pathname.yourVideos}?upload-video`);
  setUpdateType('photo');
  setChooseAlbumStep(1);
};

<button onClick={handleAddAlbum}>Add Album</button>;

  return (
    <div className={styles.sidebar}>
      <div className={styles.menuList}>
        {/* All Albums Item */}
        <div
          className={`${styles.menuItem} ${!selectedAlbum ? styles.active : ''}`}
          onClick={handleAllAlbumsClick}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              handleAllAlbumsClick();
            }
          }}
        >
          <AllAlbumsIcon className={styles.menuIcon} />
          <div className={styles.menuContent}>
            <span className={styles.menuLabel}>All Albums</span>
            <span className={styles.menuCount}>{totalAlbumsCount}</span>
          </div>
        </div>

        {/* Album Items */}
        {loading ? (
          <div className={styles.loadingState}>
            <div className={styles.skeletonItem}>
              <div className={styles.skeletonIcon} />
              <div className={styles.skeletonText} />
            </div>
            <div className={styles.skeletonItem}>
              <div className={styles.skeletonIcon} />
              <div className={styles.skeletonText} />
            </div>
            <div className={styles.skeletonItem}>
              <div className={styles.skeletonIcon} />
              <div className={styles.skeletonText} />
            </div>
          </div>
        ) : albums.length === 0 ? (
          <div className={styles.emptyState}>
            <AlbumIcon className={styles.emptyIcon} />
            <p>No albums found</p>
          </div>
        ) : (
          albums.map((album) => {
            const isSelected = selectedAlbum?.content_id === album.content_id;
            return (
              <div
                key={album.content_id}
                className={`${styles.menuItem} ${isSelected ? styles.active : ''}`}
                onClick={() => handleAlbumClick(album)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleAlbumClick(album);
                  }
                }}
              >
                <AlbumIcon className={styles.menuIcon} />
                <div className={styles.menuContent}>
                  <span className={styles.menuLabel}>{album?.title || 'Untitled Album'}</span>
                  {/* <span className={styles.menuCount}>{album?.photo_count || 0}</span> */}
                </div>
              </div>
            );
          })
        )}
                <div
                  className={`${styles.menuItem} ${styles.addCategoryButton}`}
                  onClick={handleAddAlbum}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      handleAddAlbum();
                    }
                  }}
                >
                  <AddIcon className={styles.menuIcon} />
                  <div className={styles.menuContent}>
                    <span className={styles.menuLabel}>Add Album</span>
                  </div>
                </div>
      </div>
    </div>
  );
};

export default AlbumsSidebar;
